import * as React from "react";

import { api, withAuth } from "@/lib/api";

const AdminContext = React.createContext(null);

const STORAGE_KEY = "crackoyun_admin_token";

export const AdminProvider = ({ children }) => {
  const [token, setToken] = React.useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || "";
    } catch {
      return "";
    }
  });
  const [loading, setLoading] = React.useState(false);

  const isAdmin = Boolean(token);

  React.useEffect(() => {
    try {
      if (token) window.localStorage.setItem(STORAGE_KEY, token);
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }, [token]);

  const login = async ({ username, password }) => {
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { username, password });
      setToken(res.data?.token || "");
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => setToken("");

  const adminApi = React.useMemo(() => withAuth(token), [token]);

  const value = React.useMemo(
    () => ({
      token,
      isAdmin,
      login,
      logout,
      loading,
      adminApi,
    }),
    [token, isAdmin, loading, adminApi]
  );

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};

export const useAdmin = () => {
  const ctx = React.useContext(AdminContext);
  if (!ctx) throw new Error("useAdmin must be used within <AdminProvider />");
  return ctx;
};
